import { useEffect } from 'react';
import TWNavbar from './components/TWNavbar';
import TWHero from './components/TWHero';
import TWProblems from './components/TWProblems';
import TWDeliverables from './components/TWDeliverables';
import TWShowcase from './components/TWShowcase';
import TWProcess from './components/TWProcess';
import TWPricing from './components/TWPricing';
import TWTestimonials from './components/TWTestimonials';
import TWFaq from './components/TWFaq';
import TWContactForm from './components/TWContactForm';
import TWFooter from './components/TWFooter';

export default function TvorbaWebovPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCtaClick = () => {
    const el = document.querySelector('#kontaktny-formular');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <title>Tvorba webových stránok na Slovensku | Boostio — Web do 12 dní</title>
      <meta name="description" content="Profesionálna tvorba webových stránok na Slovensku. Web do 12 pracovných dní s dizajnom, textami a SEO základmi. Konzultácia zadarmo. Od 590 €." />
      <meta name="keywords" content="tvorba webových stránok, web dizajn Slovensko, profesionálny web, webstránka pre firmu" />
      <link rel="canonical" href="https://boostio.sk/tvorba-webov" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://boostio.sk/tvorba-webov" />
      <meta property="og:title" content="Tvorba webových stránok, ktoré predávajú | Boostio" />
      <meta property="og:description" content="Web do 12 dní s dizajnom, textami a SEO. Konzultácia zadarmo. Od 590 €." />
      <meta property="og:locale" content="sk_SK" />
      <meta property="og:site_name" content="Boostio" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Tvorba webových stránok, ktoré predávajú | Boostio" />
      <meta name="twitter:description" content="Web do 12 dní s dizajnom, textami a SEO. Konzultácia zadarmo. Od 590 €." />

      <div className="min-h-screen bg-white">
        <TWNavbar onCtaClick={handleCtaClick} />
        <TWHero onCtaClick={handleCtaClick} />
        <TWProblems />
        <TWDeliverables onCtaClick={handleCtaClick} />
        <TWShowcase onCtaClick={handleCtaClick} />
        <TWProcess onCtaClick={handleCtaClick} />
        <TWPricing onCtaClick={handleCtaClick} />
        <TWTestimonials />
        <TWFaq onCtaClick={handleCtaClick} />
        <TWContactForm />
        <TWFooter />
      </div>
    </>
  );
}
